import React from 'react';
//import ProgressBar from 'react-bootstrap/ProgressBar'
import '../../../Styles/skills.css'

const Skill = ({imgSkill, nameSkill}) => {

    return (
        
            <div className="o-cont-skill">
                <img src={imgSkill} className="o-img-skill" alt={nameSkill}></img>
                <p className="o-name-skill">{nameSkill}</p>
            </div>
    );

};
export default Skill;